/**
 * @Desc
 * @Author mileS
 * @Date 2020-06-09 10:28
 * */

// 家长端
const parent = {
  id: '1',
  list: [
    {
      title: '未来魔法校·学生APP',
      des: '手机扫描二维码，下载安装',
      pic: require('../../../assets/images/logo/app-student-new.png'),
      type: 1,
      code: [
        {
          url: require('../../../assets/images/logo/parent-iphone.png'),
          platform: 'iPhone 下载',
          platformId: 2
        },
        {
          url: require('../../../assets/images/logo/parent-android.png'),
          platform: 'android 下载',
          platformId: 1
        }
      ]
    },
    {
      title: '直播云·学生APP',
      des: '手机扫描二维码，下载安装',
      pic: require('../../../assets/images/logo/live-logo.png'),
      type: 1,
      code: [
        {
          url: require('../../../assets/images/logo/live-iphone.png'),
          platform: 'iPhone 下载',
          platformId: 2
        },
        {
          url: require('../../../assets/images/logo/live-android.png'),
          platform: 'android 下载',
          platformId: 1
        }
      ]
    },
    {
      title: '直播云·学生IPad',
      des: 'IPad扫码二维码，下载安装',
      pic: require('../../../assets/images/logo/live-logo-ipad.png'),
      type: 1,
      code: [
        {
          url: require('../../../assets/images/logo/live-ipad.png'),
          platform: 'IPad 下载',
          platformId: 5
        }
      ]
    },
    {
      title: '直播云·学生PC端',
      des: '点击按钮，下载安装',
      pic: require('../../../assets/images/logo/live-logo.png'),
      type: 2,
      code: [
        {
          needLoad: 'liveCloudStudentPathForPC',
          platform: 'PC客户端下载',
          platformId: 3
        },
        {
          needLoad: 'liveCloudStudentPathForMac',
          platform: 'Mac客户端下载',
          platformId: 4
        }
      ]
    },
    {
      title: '励步云·学生APP',
      des: '手机扫描二维码，下载安装',
      pic: require('../../../assets/images/logo/logo-libu-app.png'),
      type: 1,
      code: [
        {
          url: require('../../../assets/images/logo/libu-ios-download.png'),
          platform: 'iPhone 下载',
          platformId: 2
        },
        {
          url: require('../../../assets/images/logo/libu-android-download.png'),
          platform: 'android 下载',
          platformId: 2
        }
      ]
    }
  ]
}

// 老师端
const teacher = {
  id: '1',
  list: [
    {
      title: '未来魔法校·老师APP',
      des: '手机扫描二维码，下载安装',
      pic: require('../../../assets/images/logo/app-teacher.png'),
      type: 1,
      code: [
        {
          url: require('../../../assets/images/logo/teacher-iphone.png'),
          platform: 'iPhone 下载'
        },
        {
          url: require('../../../assets/images/logo/teacher-android.png'),
          platform: 'android 下载'
        }
      ]
    },
    {
      title: '魔法黑板',
      des: '点击按钮，下载安装',
      pic: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/mofa-83.png',
      type: 2,
      code: [
        {
          needLoad: 'aiBoardLink',
          platform: 'PC客户端下载',
          platformId: 3
        },
        {
          needLoad: 'macBoardLink',
          platform: 'Mac客户端下载',
          platformId: 4
        }
      ]
    },
    {
      title: '魔法黑板2.0',
      key: 'blackboard',
      des: '23年9月1日后新合作或升级的机构，请下载此版本',
      pic: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/mofa-82.png',
      type: 2,
      code: [
        {
          needLoad: 'magicBlackboardLink',
          platform: 'PC客户端下载',
          platformId: 3
        },
        {
          needLoad: 'macBlackboardLink',
          platform: 'Mac客户端下载',
          platformId: 4
        }
      ]
    },
    {
      title: '超级课件授课端',
      key: 'superCoursewareLink',
      des: 'iPad扫描下载，仅支持iOS13及以上',
      pic: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/app16.png',
      type: 1,
      code: [
        {
          url: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/teacher-iPad.png?v20240928',
          platform: 'iPad 下载'
        }
      ]
    },
    {
      title: 'Phoenix·辅导端Pad',
      des: 'iPad扫描二维码，下载安装',
      pic: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/app10.png',
      type: 1,
      code: [
        {
          url: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/phoenix-pad-ios.png',
          platform: 'IPad 下载',
          platformId: 5
        }
      ]
    },
    {
      title: '直播云·老师PC端',
      des: '点击按钮，下载安装',
      pic: require('../../../assets/images/logo/live-logo-teacher.png'),
      type: 2,
      code: [
        {
          needLoad: 'liveCloudTeacherPathForPC',
          platform: 'PC客户端下载',
          platformId: 3
        },
        {
          needLoad: 'liveCloudTeacherPathForMac',
          platform: 'Mac客户端下载',
          platformId: 4
        }
      ]
    },
    {
      title: 'CLASSROOM',
      des: '点击按钮，下载安装',
      pic: require('../../../assets/images/logo/logo-libu.png'),
      type: 2,
      code: [
        {
          needLoad: 'libuCloudPath',
          platform: 'PC客户端下载',
          platformId: 3 // 类型9指一个zip包可以同时适用mac 和 pc
        },
        {
          needLoad: 'libuCloudPathForMac',
          platform: 'Mac客户端下载',
          platformId: 4
        }
      ]
    },
    {
      title: '乐加乐授课端',
      key: 'lejiale',
      des: '点击按钮，下载安装',
      pic: require('@/assets/pngs/lejiale.png'),
      type: 2,
      code: [
        {
          needLoad: 'lejialeLinkForPC',
          platform: 'PC客户端下载',
          platformId: 3
        }
      ]
    }
  ]
}

// 教室端
const room = {
  list: [
    {
      title: '超级课件授课端',
      des: '如需授权码，请联系运营老师',
      pic: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/app15.png',
      type: 2,
      code: [
        {
          needLoad: 'superCoursewareLink',
          platform: 'PC客户端下载',
          platformId: 3
        }
      ]
    },
    {
      title: '魔法校教室端',
      des: '点击按钮，下载安装',
      pic: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/app14.png',
      type: 2,
      code: [
        {
          needLoad: 'AILink',
          platform: 'PC客户端下载',
          platformId: 3
        }
      ]
    },
    {
      title: '谷歌浏览器',
      des: '点击按钮，下载安装',
      pic: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/app7.png',
      type: 2,
      code: [
        {
          needLoad: 'chromeLink',
          platform: 'PC客户端下载',
          platformId: 3
        }
      ]
    }
  ]
}

const list = [parent, teacher, room]

const platformMapper = [
  {
    id: 1,
    name: 'android 下载'
  },
  {
    id: 2,
    name: 'iPhone 下载'
  },
  {
    id: 3,
    name: 'PC客户端下载'
  },
  {
    id: 4,
    name: 'Mac客户端下载'
  },
  {
    id: 5,
    name: 'IPad 下载'
  }
]

export { list, platformMapper }
